import { MenuIcon } from '../../../../ui';
import { MenuLabel } from '../mobile/MobileNavigation.styles';
import { ToggleButton } from './MenuButton.styles';

interface IMenuButtonProps {
	onClick: () => void;
}

export const MenuButton = ({ onClick }: IMenuButtonProps) => (
	<ToggleButton onClick={onClick} aria-label="Open menu">
		<MenuIcon />
		<MenuLabel>Menu</MenuLabel>
	</ToggleButton>
);
